import React from "react";
import { Button, ListGroup } from "react-bootstrap";
import { useDispatch } from "react-redux";
import styles from "./TeamDetailInviteesRow.module.scss";

interface Props {
    email: string;
    teamId: string;
}

const TeamDetailInviteesRow: React.FC<Props> = ({ email, teamId }) => {
    const dispatch = useDispatch();

    const onDeletePressed = React.useCallback(() => {
        dispatch({
            type: "com.sage.actions.team.IDeleteTeamInvite",
            email,
            teamId,
        } as sage.actions.team.IDeleteTeamInvite);
    }, [email, dispatch, teamId]);

    return (
        <ListGroup.Item>
            <div className={styles.container}>
                <span className={styles.content}>{email}</span>
                <Button onClick={onDeletePressed} size="sm" variant="danger">
                    Delete
                </Button>
            </div>
        </ListGroup.Item>
    );
};

export default TeamDetailInviteesRow;
